import CustomDialog from 'components/CustomDialog';
import MapTextField from 'components/Global/MapTextField';
import React, { useState } from 'react';
import { produce } from 'utility/general';

const TableDialog = ({
    defaultFormList = {},
    selectedRow = {},
    isShow = true,
    title = 'test',
    onSubmit = () => null,
    onClose = () => null,
    onValidationChange = () => null,
}) => {
    const [validation, setValidation] = useState({});
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);

    return (
        <div>
            <CustomDialog
                title={title}
                isShow={isShow}
                onCancel={() => {
                    // clear the input form
                    onClose();
                }}
                width={500}
                onConfirm={() => {
                    const isValid = Object.values(validation).every((item) => item);

                    if (!isValid) {
                        setForceErrorDisplay(true);
                        return;
                    }

                    onSubmit();
                }}
            >
                {Object.values(defaultFormList)?.map((item, index) => {
                    if (item.type === 'subTitle') {
                        return (
                            <div style={{ paddingBottom: 10 }}>
                                <div
                                    key={`subTitle-${index}`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        paddingBottom: 5,
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                        borderBottom: '1px solid #dcdcdc',
                                    }}
                                >
                                    {item.name}
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div key={item.name} style={{ display: 'flex', alignItems: 'center', paddingBottom: 20 }}>
                            <div style={{ width: 100, paddingRight: 10 }}>{item.label}: </div>
                            <div style={{ flexGrow: 1 }}>
                                <MapTextField
                                    maxLength={item.maxLength}
                                    isValidValue={(e) => {
                                        setValidation(
                                            produce((draft) => {
                                                draft[item.name] = e;
                                            }),
                                        );
                                    }}
                                    forceErrorDisplay={forceErrorDisplay}
                                    item={item}
                                    handleFormData={(e) => {
                                        item?.onChange?.(e);
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </CustomDialog>
        </div>
    );
};

export default TableDialog;
